<template>
  <section class="forbidden-container vector-background col center">
    <ErrorMaintenance
      :img="img"
      :title="title"
      :msg="msg"
      :goto="goto"
      :isPrimary="isPrimary"
      :isDanger="isDanger"
    />
  </section>
</template>

<script>
import ErrorMaintenance from "@/components/ErrorPage";
export default {
  name: "Forbidden",
  components: {
    ErrorMaintenance
  },
  data() {
    return {
      img: "",
      title: "",
      msg: "",
      goto: [],
      isPrimary: false,
      isDanger: true
    };
  },
  props: {
    routerPath: String
  },
  methods: {
    roleForbidden() {
      this.img = require("@/assets/img/failed-selection.png");
      this.title = "Akses ditolak";
      this.msg = "Anda tidak memiliki hak akses di halaman ini !";
      this.goto = [
        {
          str: "Kembali ke beranda",
          link: "/"
        }
      ];
    },
    loginForbidden() {
      this.img = require("@/assets/img/failed-selection.png");
      this.title = "Anda belum masuk";
      this.msg = "Masuk terlebih dahulu untuk mengakses halaman ini !";
      this.goto = [
        {
          str: "Masuk ke akun",
          link: "/sign/in"
        }
      ];
    },
    periodForbidden() {
      this.img = require("@/assets/img/failed-selection.png");
      this.title = "Periode belum dibuka";
      this.msg = "Anda belum bisa mengakses halaman ini !";
      this.goto = [
        {
          str: "Kembali ke beranda",
          link: "/"
        }
      ];
    },
    mustFillSurveyForbidden() {
      this.img = require("@/assets/img/failed-selection.png");
      this.title = "Anda belum mengisi survey. ";
      this.msg = "Isi survey terlebih dahulu !";
      this.goto = [
        {
          str: "Isi survey",
          link: "/survey-form"
        }
      ];
    }
  },
  created() {
    if (this.routerPath == "notLogin") {
      this.loginForbidden();
    } else if (this.routerPath == "incorrectRole") {
      this.roleForbidden();
    } else if (this.routerPath == "notInPeriod") {
      this.periodForbidden();
    } else if (this.routerPath == "notFillSurvey") {
      this.mustFillSurveyForbidden();
    }
  }
};
</script>

<style lang="scss" scoped>
.forbidden-container {
  min-height: inherit;
}
</style>